export const Footer = ({
  currentStep,
  onBack,
  onNext,
  isLast,
  confirmed,
  isSubmitting,
}) => {
  return (
    <div className="flex justify-between mt-6 mb-9">
      {/* BACK BUTTON */}
      <button
        onClick={onBack}
        disabled={currentStep === 1 || isSubmitting}
        className="px-4 py-2 text-sm rounded-lg border bg-slate-50 disabled:opacity-50"
      >
        Back
      </button>

      {/* NEXT / CONFIRM BUTTON */}
      <button
        onClick={onNext}
        disabled={isSubmitting || (isLast && !confirmed)}
        className={`flex items-center justify-center gap-2 px-5 py-2 text-sm rounded-lg text-white transition
          ${
            isSubmitting || (isLast && !confirmed)
              ? "bg-slate-300 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }
        `}
      >
        {/* LOADING STATE */}
        {isSubmitting && (
          <svg
            className="h-4 w-4 animate-spin text-white"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        )}

        {/* BUTTON TEXT */}
        {isSubmitting
          ? "Confirming..."
          : isLast
          ? "Confirm & Activate"
          : "Next"}
      </button>
    </div>
  );
};



// export const Footer = ({
//   currentStep,
//   onBack,
//   onNext,
//   isLast,
//   confirmed,
//   isSubmitting,
// }) => {
//   return (
//     <div className="flex justify-between mt-6">
//       <button
//         onClick={onBack}
//         disabled={currentStep === 1 || isSubmitting}
//         className="px-4 py-2 text-sm rounded-lg border bg-slate-50 disabled:opacity-50"
//       >
//         Back
//       </button>

//       <button
//         onClick={onNext}
//         disabled={isSubmitting || (isLast && !confirmed)}
//         className={`px-5 py-2 text-sm rounded-lg text-white transition
//           ${
//             isSubmitting || (isLast && !confirmed)
//               ? "bg-slate-300 cursor-not-allowed"
//               : "bg-blue-600 hover:bg-blue-700"
//           }
//         `}
//       >
//         {isSubmitting
//           ? "Confirming..."
//           : isLast
//           ? "Confirm & Activate"
//           : "Next"}
//       </button>
//     </div>
//   );
// };



// export const Footer = ({ currentStep, onBack, onNext, isLast }) => (
//   <div className="flex justify-between mt-6">
//     <button
//       onClick={onBack}
//       disabled={currentStep === 1}
//       className="px-4 py-2 text-sm rounded-lg border bg-slate-50 disabled:opacity-50"
//     >
//       Back
//     </button>

//     <button
//       onClick={onNext}
//       className="px-5 py-2 text-sm rounded-lg bg-blue-600 text-white"
//     >
//       {isLast ? "Confirm & Activate" : "Next"}
//     </button>
//   </div>
// );